import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  InputAdornment,
  IconButton
} from "@mui/material";

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export default function ChangePasswordDialog({
  open,
  user,
  onClose,
  onSave
}) {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (open) setPassword("");
    setShowPassword(false);
  }, [open]);

  const isValid = password.length >= 8;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Change Password</DialogTitle>

      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          Enter the new password for user{" "}
          <strong style={{ fontWeight: 500 }}>{user?.fullName}</strong> (
          {user?.email})
        </Typography>

        <TextField
          autoFocus
          fullWidth
          type={showPassword ? "text" : "password"}
          label="New password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }
          }}
        />

        <Typography
          variant="caption"
          sx={{
            mt: 1,
            display: "block"
          }}
        >
          Minimum 8 characters
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>

        <Button
          variant="contained"
          disabled={!isValid}
          onClick={() => onSave(password)}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}